"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentsSchema = exports.isoDateSchema = exports.documentRequestSchema = exports.documentSourceSchema = void 0;
const zod_1 = require("zod");
const document_api_1 = require("./document.api");
const date_fns_1 = require("date-fns");
exports.documentSourceSchema = zod_1.z.nativeEnum(document_api_1.DocumentSource);
exports.documentRequestSchema = zod_1.z.array(zod_1.z.object({
    date: zod_1.z.string(),
    file_id: zod_1.z.number().int(),
    creditor_id: zod_1.z.string(),
    tags: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    name: zod_1.z.string().optional(),
    source: exports.documentSourceSchema,
}));
exports.isoDateSchema = zod_1.z
    .string()
    .refine(v => (0, date_fns_1.isValid)((0, date_fns_1.parseISO)(v)), 'Invalid date format. Expected ISO 8601');
exports.getDocumentsSchema = zod_1.z
    .object({
    filter_date_by: zod_1.z.nativeEnum(document_api_1.GetDocumentsFilterBy).optional(),
    date: exports.isoDateSchema.optional(),
    start_date: exports.isoDateSchema.optional(),
    end_date: exports.isoDateSchema.optional(),
    creditor_id: zod_1.z.string().or(zod_1.z.array(zod_1.z.string())).optional(),
    approval: zod_1.z
        .enum([
        'APPROVED',
        'DISAPPROVED',
        'PENDING',
    ])
        .optional(),
    payment_status: zod_1.z.nativeEnum(document_api_1.DocumentPaymentStatus).optional(),
    order_by: zod_1.z.enum(document_api_1.SORTABLE_DOCUMENT_FIELDS).optional(),
    order_mode: zod_1.z.enum(['ASC', 'DESC']).optional(),
    source: exports.documentSourceSchema.optional(),
    page: zod_1.z.coerce.number().optional(),
    limit: zod_1.z.coerce.number().optional(),
    plan_id: zod_1.z.string().optional(),
    tag_name: zod_1.z.string().optional(),
    tag_value: zod_1.z.string().optional(),
})
    .refine(({ order_by, order_mode }) => {
    if ((order_by && !order_mode) || (!order_by && order_mode))
        return false;
    return true;
}, 'Both order_by and order_mode are required when at least one is provided');
